var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-active-status"},[_vm._v(" "+_vm._s(`${_vm.$t(_vm.isActive ? 'activeText' : 'inactiveText')} ${_vm.yearLabel}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }